import { render, staticRenderFns } from "./CheckAfterPack.vue?vue&type=template&id=d36ddbfc&scoped=true&"
import script from "./CheckAfterPack.vue?vue&type=script&lang=js&"
export * from "./CheckAfterPack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36ddbfc",
  null
  
)

export default component.exports